'use client'
import React, { FC } from 'react'

import InscriptionContent from '../inscription-content'

import styles from './InscriptionCardSmall.module.css'
import { Inscription } from '@/utils/types/inscription'
import classNames from 'classnames'
import formatHiddenChars from '@/utils/format-hidden-chars'
import RarityPills from '@/components/rarity-pills'

const InscriptionCardSmall: FC<{
	className?: string
	bodyClassName?: string
	inscription: Inscription
	hideSubtitle?: boolean
	subtitle?: string
	isModal?: boolean
	children?: React.ReactNode
}> = (props) => {
	const { className, bodyClassName, hideSubtitle, inscription, subtitle, isModal: _isModal } = props

	return (
		<div className={classNames({ [(props.className as any)]: !!className }, styles.root)}>
			<div className="flex items-center gap-4">
				<InscriptionContent
					className={classNames(styles.content, {
						[styles.punks]: inscription?.collection?.slug == 'bitcoinpunks'
					})}
					inscription={props.inscription}
					smallCard={true}
				/>
				<div className={classNames({ [(props.bodyClassName as any)]: !!bodyClassName }, styles.body)}>
					<div className={styles.row}>
						<div className={classNames(styles.title, 'text-md', 'bold')}>
							{inscription?.meta?.name ? (
								<p>{formatHiddenChars(inscription?.meta?.name)}</p>
							) : inscription?.escrow?.name ? (
								<p>{inscription?.escrow?.name}</p>
							) : inscription?.num != null ? (
								<p>{`Inscription #${inscription?.num}`}</p>
							) : (
								<p>{`${inscription?.id?.slice(0, 6)}...${inscription?.id?.slice(-6)}`}</p>
							)}
						</div>
						{/** */}
					</div>
					{!subtitle && !hideSubtitle && (
						<div className={classNames(styles.subtitle, 'text-xs', 'semibold')}>
							{inscription?.meta?.name && inscription?.num != null ? (
								<p>
									INSCRIPTION <span className={styles.number}>#{inscription?.num}</span>
								</p>
							) : (
								<p>{inscription?.content_type}</p>
							)}
						</div>
					)}
					{subtitle && (
						<div className={classNames(styles.subtitle, 'text-xs', 'semibold')}>{subtitle}</div>
					)}
					<RarityPills
						className={styles.rankMobile}
						pillClassName={styles.rankMobile}
						inscription={inscription}
					/>
				</div>
			</div>
			{props.children}
		</div>
	)
}

export default InscriptionCardSmall
